import { useMemo } from 'react';

import type { ConceptGroupOption } from '../types';
import { buildConceptGroupMaps } from '../utils/analyticalVariable.utils';
import type { ConceptGroupMaps } from '../utils/analyticalVariable.utils';

/** Memoised concept-group lookup maps derived from the options array. */
export const useConceptGroupMaps = (
  conceptGroups: ConceptGroupOption[] | undefined
): ConceptGroupMaps => useMemo(() => buildConceptGroupMaps(conceptGroups), [conceptGroups]);
